import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

// Thin wrapper over the shared ConfirmationModal (same pattern as
// Templates/DeleteTemplateConfirmationModal) so the delete dialog matches the
// rest of the app. External props are unchanged.
const DeleteConfirmationModal = ({
  show,
  templateName,
  isDeleting,
  onClose,
  onConfirm,
}) => (
  <ConfirmationModal
    show={show}
    onHide={onClose}
    onConfirm={onConfirm}
    title={`Delete ${templateName}?`}
    confirmLabel="Delete"
    confirmVariant="danger"
    isLoading={isDeleting}
    loadingLabel="Deleting…"
    className="contract-confirm-modal-wrapper"
  >
    <p className="mb-0 contract-delete-text">This can't be undone.</p>
  </ConfirmationModal>
);

export default DeleteConfirmationModal;
